export const quotes = [
    "if you want it, you should have it - Shopaholic"
  ];